import React, { useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import MasterData from "../Data/masterData";
import "../style/ProductDetails.css";
import emailjs from "emailjs-com";

const ProductDetails = () => {
  const { category, type, model, id } = useParams();
  const form = useRef();


  const product = MasterData?.[category].subCategories
    .find((item) => item.id === type)
    ?.list.find((p) => p.id === model);

  let variant;
  if (!product?.variants) {
    variant = product;
  } else {
    variant = product?.variants.find((v) => v.id === id);
  }

  const defaultImage =
    variant?.img ||
    (variant.images && variant.images.length > 0 && variant.images[0]) ||
    "";

  const [selectedImg, setSelectedImg] = useState(defaultImage);

  if (!product || !variant) {
    return <h2 className="product-title">⚠ Product not found</h2>;
  }

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_made04j",
        "template_jh8k3hg",
        form.current,
        "-86tPl3RmB96yNv4j"
      )
      .then(
        (result) => {
          console.log("Email Sent:", result.text);
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          console.error("Email Error:", error.text);
          alert("Failed to send message.");
        }
      );
  };

  return (
    <div className="product-details-container">
      <h1 className="product-title">{variant.name}</h1>
      <p className="product-description">{variant.description}</p>

      <div className="product-view-details-table">
        <div className="details-top">

          <img
            src={selectedImg}
            alt={variant.name}
            className="product-image"
          />

       
          {variant.images && variant.images.length > 0 && (
            <div className="thumbnails">
              {variant.images.map((thumb, idx) => (
                <img
                  key={idx}
                  src={thumb}
                  alt={`${variant.name} ${idx + 1}`}
                  className="thumbnail-img"
                  onClick={() => setSelectedImg(thumb)}
                  style={{
                    cursor: "pointer",
                    border: selectedImg === thumb ? "2px solid #000" : "none",
                  }}
                />
              ))}
            </div>
          )}
        </div>

        <div className="basic-info">
          <h2 className="section-title">Basic Information</h2>
          <table className="basic-info-table">
            <tbody>
              <tr>
                <td><strong>BRAND:</strong></td>
                <td>{variant.brand || "A-OK"}</td>
              </tr>
              <tr>
                <td><strong>ITEM NO.:</strong></td>
                <td>{variant.model || variant.id}</td>
              </tr>
              <tr>
                <td><strong>COLOR:</strong></td>
                <td>{variant.color || "Yellow / Custom"}</td>
              </tr>
              <tr>
                <td><strong>LEAD TIME:</strong></td>
                <td>{variant.leadTime || "2-3 Months"}</td>
              </tr>
              <tr>
                <td><strong>ORDER (MOQ):</strong></td>
                <td>{variant.order || "100 pcs"}</td>
              </tr>
              <tr>
                <td><strong>WARRANTY:</strong></td>
                <td>{variant.warranty || "Up to 5 years"}</td>
              </tr>
              <tr>
                <td><strong>CERTIFICATE:</strong></td>
                <td>
                  {variant.certificate ||
                    "CE/CB/TUV/C-TICK/R&TTE/FCC/RoHS/C-UL-US/C-TUV-US"}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="button-group">
            <Link to="/Contact">
              <button className="btn-inquiry">Inquiry Now</button>
            </Link>
          </div>
        </div>
      </div>


      {variant.features && (
        <>
          <h2 className="section-title">Features</h2>
          <ul className="product-list">
            {variant.features.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        </>
      )}

      {variant.imgs && (
        <ul className="product-list-image">
          {variant.imgs.map((im, i) => (
            <p key={i}>
              <img src={im} alt={`product-img-${i}`} />
            </p>
          ))}
        </ul>
      )}


      {variant.functions && (
        <>
          <h2 className="section-title">Functions</h2>
          <ul className="product-list">
            {variant.functions.map((fn, i) => (
              <li key={i}>{fn}</li>
            ))}
          </ul>
        </>
      )}

 
      {variant.specs && (
        <>
          <h2 className="section-title">Specifications</h2>
          <table className="specs-table">
            <thead>
              <tr>
                <th>Model</th>
                <th>Torque</th>
                <th>RPM</th>
                <th>Diameter</th>
                <th>Current</th>
                <th>Tube</th>
                <th>Frequency</th>
                <th>Voltage</th>
                <th>Power</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(variant.specs) ? (
                variant.specs.map((s, i) => (
                  <tr key={i}>
                    <td>{s.model}</td>
                    <td>{s.torque}</td>
                    <td>{s.rpm}</td>
                    <td>{s.diameter}</td>
                    <td>{s.current}</td>
                    <td>{s.tube}</td>
                    <td>{s.frequency}</td>
                    <td>{s.voltage}</td>
                    <td>{s.power}</td>
                    <td>{s.ip}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>{variant.specs.model}</td>
                  <td>{variant.specs.torque}</td>
                  <td>{variant.specs.rpm}</td>
                  <td>{variant.specs.diameter}</td>
                  <td>{variant.specs.current}</td>
                  <td>{variant.specs.tube}</td>
                  <td>{variant.specs.frequency}</td>
                  <td>{variant.specs.voltage}</td>
                  <td>{variant.specs.power}</td>
                  <td>{variant.specs.ip}</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}

      <div className="button-group">
        <Link to="/Contact">
          <button className="btn-inquiry">Inquiry Now</button>
        </Link>
        <Link to="/product" className="btn-back">← Back</Link>
      </div>

  
      <div className="contact-form-container">
        <h2 className="section-title">Leave a Message</h2>
        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <input type="hidden" name="subject" value={variant.name} />

          <input type="email" name="email" placeholder="Your Email *" required />
          <input type="text" name="phone" placeholder="Tel/Whatsapp" />
          <textarea
            name="message"
            placeholder="Enter product details..."
            required
          />

          <button type="submit" className="btn-inquiry">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ProductDetails;